import { render, staticRenderFns } from "./IssueDivider.vue?vue&type=template&id=1d672cb6&scoped=true&"
import script from "./IssueDivider.vue?vue&type=script&lang=ts&"
export * from "./IssueDivider.vue?vue&type=script&lang=ts&"
import style0 from "./IssueDivider.vue?vue&type=style&index=0&id=1d672cb6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d672cb6",
  null
  
)

export default component.exports